// Pitch category buckets — AI-generated by functions/aiSummary.js. Each pitch
// belongs to exactly one category (unlike self-ID, where a founder can carry
// multiple tags), so rows in `categoryBreakdown` DO sum to the applicant total.
// Mirrors PITCH_CATEGORIES in functions/aiSummary.js — keep in sync when
// categories change.
export const PITCH_CATEGORIES = [
  "Food & Drink",
  "Products",
  "Wellness",
  "Arts & Media",
  "Education",
  "Services",
  "Tech",
  "Civic & Impact",
];
